import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import Style from './RichContent.module.scss';
import { Box } from "@mui/material";

const SANITIZE_CONFIG = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder'],
};

export default function RichContent({ htmlFileUrl }) {
    const [html, setHtml] = useState(null);

    useEffect(() => {
        let isMounted = true;

        fetch(htmlFileUrl)
            .then((res) => res.text())
            .then((text) => {
                if (isMounted) setHtml(DOMPurify.sanitize(text, SANITIZE_CONFIG));
            })
            .catch(() => {
                if (isMounted) setHtml('');
            });

        return () => {
            isMounted = false;
        };
    }, [htmlFileUrl]);

    if (html === null) {
        return (
            <Box className={Style.loading}>Loading content...</Box>
        );
    }

    return (
        <Box
            className={Style.richContent}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
